"use strict";

(() => {
  const bottomMenu = document.querySelector(".p-bottomMenu");
  if (!bottomMenu) return;

  const isContactPage =
    document.querySelector("#contact-form") ||
    document.querySelector(".p-bottomMenuForm") ||
    /contact/.test(location.pathname);
  if (isContactPage) {
    bottomMenu.classList.remove("-is-visible");
    bottomMenu.setAttribute("aria-hidden", "true");
    return;
  }

  const fv = document.querySelector(".p-fv");
  const isHallDetailPage = document.querySelector(".p-hallDetail");
  const bottomCTA = document.querySelector(".p-bottomCTA");
  const hideTarget = bottomCTA || document.querySelector(".p-footer");
  const closeBtn = bottomMenu.querySelector(".p-bottomMenu__close");

  let isHideTargetVisible = false;
  let isUserClosed = false;

  const getFvBottom = () => {
    if (fv) {
      return fv.getBoundingClientRect().bottom + window.scrollY;
    }
    return window.innerHeight;
  };

  const setVisible = (show) => {
    bottomMenu.classList.toggle("-is-visible", show);
    bottomMenu.toggleAttribute("aria-hidden", !show);
  };

  const update = () => {
    const scrollY = window.scrollY;
    const fvBottom = getFvBottom();
    const resetClosedAt = isHallDetailPage ? 0 : fvBottom;

    if (scrollY <= resetClosedAt) {
      isUserClosed = false;
    }

    const isPastThreshold = isHallDetailPage ? scrollY > 0 : scrollY > fvBottom;
    const show = isPastThreshold && !isHideTargetVisible && !isUserClosed;
    setVisible(show);
  };

  if (hideTarget) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        isHideTargetVisible = entry.isIntersecting;
        update();
      },
      { threshold: 0 }
    );
    observer.observe(hideTarget);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      isUserClosed = true;
      setVisible(false);
    });
  }

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update, { passive: true });
  update();
})();
